"use client";

import React from "react";

import { useBoundaryCombineActionsOptional } from "@/app/(internal)/panel/(maps)/map/_contexts/boundary-combine-actions-context";
import { Button } from "@/components/flowbite/button";
import { dictionaries } from "@/dictionaries/content";

export const CombineSelectedBoundariesButton: React.FC = () => {
  const actions = useBoundaryCombineActionsOptional();
  const combineLabel =
    dictionaries.mapPage?.boundaryPanel?.combineSelectedBoundaries ?? "Combine selected boundaries";

  if (!actions?.showCombineButton) {
    return null;
  }

  const handleCombine = async () => {
    await actions.combineSelectedBoundaries();
  };

  return (
    <Button
      className="w-full"
      typography="bodyMMedium"
      variant="white"
      onClick={handleCombine}
    >
      {combineLabel}
    </Button>
  );
};

CombineSelectedBoundariesButton.displayName = "CombineSelectedBoundariesButton";
